import { createSalesOrderFromCustomerOrder } from '#/api/crmMgmt/customerOrder/createSalesOrder';
import { getCustomerOrderApiErrorMessage } from '#/modules/crmMgmt/customerOrder/helper/apiError';

export function getCreateSalesOrderFromDraftErrorMessage(error) {
  if (!error?.response && error?.message) {
    return error.message;
  }
  return getCustomerOrderApiErrorMessage(error, '建立銷貨單失敗');
}

/**
 * 單張：`POST …/customer-order/{id}/sales-order` → 完整 DRAFT。
 *
 * @param {string} customerOrderId
 * @param {object} draft full DRAFT body（camel；serialize 見 toCreateSalesOrderBody）
 */
export async function createSalesOrderFromCustomerOrderDraft(customerOrderId, draft) {
  if (!customerOrderId) {
    throw new Error('缺少客戶訂單');
  }
  return createSalesOrderFromCustomerOrder(customerOrderId, draft);
}

/**
 * 依預交日組數逐張 `POST …/sales-order`（獨立 Transaction）。
 * **禁止** batch（route retired）。
 *
 * @param {string} customerOrderId
 * @param {object[]} items
 * @param {{ onGroupStart?: Function, onGroupSuccess?: Function }} [hooks]
 */
export async function createSalesOrdersFromCustomerOrderDrafts(
  customerOrderId,
  items,
  { onGroupStart, onGroupSuccess } = {},
) {
  if (!customerOrderId) {
    throw new Error('缺少客戶訂單');
  }
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error('沒有待建立的預交日');
  }

  const succeeded = [];
  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];
    const groupNumber = item.groupNumber ?? index + 1;
    onGroupStart?.(index, items.length, groupNumber);
    try {
      const result = await createSalesOrderFromCustomerOrderDraft(
        customerOrderId,
        item,
      );
      if (!result?.data?.id) {
        throw new Error('建立成功但未取得銷貨單編號');
      }
      succeeded.push(result);
      onGroupSuccess?.(item.groupKey, result);
    } catch (error) {
      const detail = getCreateSalesOrderFromDraftErrorMessage(error);
      const parts = [`第 ${groupNumber} 組失敗：${detail}`];
      if (succeeded.length > 0) {
        parts.push('已成功的銷貨單會留下。');
      }
      throw new Error(parts.join(' '), { cause: error });
    }
  }
  return succeeded;
}
